import { render, staticRenderFns } from "./ChoiceValueDocumentsUploader.vue?vue&type=template&id=5e38178d&scoped=true&"
import script from "./ChoiceValueDocumentsUploader.vue?vue&type=script&lang=ts&"
export * from "./ChoiceValueDocumentsUploader.vue?vue&type=script&lang=ts&"
import style0 from "./ChoiceValueDocumentsUploader.vue?vue&type=style&index=0&id=5e38178d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e38178d",
  null
  
)

export default component.exports